import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { Task1120Tracker } from "types/Models/TaskTracker";

export const MiRaisedOnColumn = ({ row }: { row: Task1120Tracker }) => {
  const [updateTaskAssignee] = useUpdateTaskAssigneeAdminMutation();
  const { alertToast, successToast } = useToast();

  const handleDateChange = async (date: Date) => {
    try {
      await updateTaskAssignee({
        taskId: row.task_uuid,
        mi_raised_on: dayjs(date).format(YYYY_MM_DD),
      }).unwrap();
      successToast({ message: "MI raised on date updated" });
    } catch (error: any) {
      alertToast({
        message:
          error?.data?.error?.message || "Failed to update MI raised on date",
      });
    }
  };

  const taskId = row.task_uuid;
  const oneYearAgo = dayjs().subtract(1, "year").toDate();

  return (
    <Formik
      onSubmit={() => {}}
      initialValues={{ mi_raised_on: row.mi_raised_on }}
    >
      {({ setFieldValue }) => (
        <Form className="t-w-full t-m-0" onClick={(e) => e.stopPropagation()}>
          <Field name="mi_raised_on">
            {({ field }: FieldProps) => (
              <DateInput
                {...field}
                portalId={"mi_raised_on_portal" + taskId}
                minDate={oneYearAgo}
                onDateChange={(date) => {
                  setFieldValue("mi_raised_on", date);
                  handleDateChange(date);
                }}
              />
            )}
          </Field>
        </Form>
      )}
    </Formik>
  );
};
